import { useQuery } from '@tanstack/react-query';
import { get } from '../services/api';

interface AccessResponse {
  data: { allowed: boolean };
}

/**
 * Probe whether the current user can run the Scan Station for `eventId`.
 * Backed by GET /events/:eventId/scan-station/access.
 *
 * Returns a React Query result whose `.data` is `boolean | undefined`
 * (true=allowed, false=denied, undefined while loading).
 */
export function useStadiumOperatorAccess(eventId: string | undefined) {
  return useQuery({
    queryKey: ['scan-station', 'access', eventId],
    enabled: !!eventId,
    staleTime: 60 * 1000,
    queryFn: async () => {
      const res = await get<AccessResponse>(`/events/${eventId}/scan-station/access`);
      return res.data.allowed;
    },
  });
}
